import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';


@Component({
    components: {
        offer: require('~/components/catalog/offer/').default,
        InfiniteLoading: require('~/components/common/scroll-loading-trigger').default,
        Loader: require('~/components/common/loader-block').default,
    },
})
export default class InfiniteCatalogComponent extends Vue {

    @prop({required: true})
    public items: Offer[];

    @prop({default: 'auto'})
    public type: InfinityLoaderType;

    @prop({default: null})
    public id;

    @prop({default: true})
    public fullscreen;

    @prop({default: false})
    public loading;

    private state: 'loading'|'loaded'|'complete' = 'loaded';

    public loadMore() {

        if (this.state === 'loading' || this.state === 'complete') {
            return;
        }

        this.state = 'loading';

        this.$emit('loadMore', {
            loaded: () => this.setState('loaded'),
            complete: () => this.setState('complete'),
            id: this.id,
        });
    }

    public reset() {
        if (this.type === 'auto' && this.$refs.loader) {
            (this.$refs.loader as any).reset();
        }

        this.state = 'loaded';
    }

    public attemptLoad() {

        this.loadMore();
    }

    private autoLoad(loaded: () => void, complete: () => void) {
        if (this.state === 'loading' || this.state === 'complete') {
            return;
        }

        this.state = 'loading';

        this.$emit('loadMore', {
            loaded: () => {this.state = 'loaded'; loaded()},
            complete: () => {this.state = 'complete'; complete()},
            id: this.id,
        });
    }

    private setState(state: 'loaded'|'complete') {

        this.state = state;
    }
}
